import { UploadErrorType } from '../types';
export function normalizeCpf(value) {
    return (value ?? '').replace(/[.\-/\s]/g, '').padStart(11, '0');
}
export function mapBackendSuccessToValidatedRows(dtos) {
    return dtos.map((dto, index) => {
        const fullName = `${dto.firstName ?? ''} ${dto.lastName ?? ''}`.trim();
        const document = dto.document ?? '';
        return {
            rowIndex: index + 2,
            name: fullName,
            cpf: document,
            normalizedCpf: normalizeCpf(document),
            value: dto.productValue ?? 0,
            daysQuantity: dto.productDaysQuantity ?? 0,
            discountValue: dto.productDiscountValue ?? 0,
        };
    });
}
function extractEnvelopeBody(envelope) {
    if (envelope.details && typeof envelope.details === 'object') {
        return envelope.details;
    }
    if (envelope.data && typeof envelope.data === 'object') {
        return envelope.data;
    }
    return undefined;
}
export function readErrorEnvelope(error) {
    if (!error || typeof error !== 'object') {
        return {};
    }
    const maybe = error;
    const body = extractEnvelopeBody(maybe);
    const result = body && 'result' in body ? body.result : undefined;
    return { status: maybe.status, result };
}
export function extractValidationFailure(status, result) {
    if (status !== 422 || !result || typeof result !== 'object') {
        return null;
    }
    const typed = result;
    if (!Array.isArray(typed.errors)) {
        return null;
    }
    return { sheet: typed.sheet ?? '', errors: typed.errors };
}
export function mapFileLevelError(status) {
    if (status === 413) {
        return { kind: 'FILE_ERROR', uploadErrorType: UploadErrorType.FILE_SIZE, inline: true };
    }
    if (status === 415) {
        return { kind: 'FILE_ERROR', uploadErrorType: UploadErrorType.INVALID_FORMAT, inline: true };
    }
    return null;
}
function mapBackendErrors(errors) {
    return errors.map(item => ({
        rowIndex: item.line,
        column: (item.column ?? '').toUpperCase(),
        message: item.errorMessage ?? '',
    }));
}
export function extractOutcome(error) {
    const { status, result } = readErrorEnvelope(error);
    const validationFailure = extractValidationFailure(status, result);
    if (validationFailure) {
        return {
            kind: 'VALIDATION_FAILED',
            errors: mapBackendErrors(validationFailure.errors),
            errorSheet: validationFailure.sheet,
        };
    }
    return mapFileLevelError(status) ?? { kind: 'SYSTEMIC_ERROR' };
}
